import { t } from '@/core/localization';
import boxesStackedIcon from '@/core/svg/fa/boxes-stacked.svg';
import chartColumnIcon from '@/core/svg/fa/chart-column.svg';
import dollyIcon from '@/core/svg/fa/dolly.svg';
import fileExcelIcon from '@/core/svg/fa/file-excel.svg';
import fileSignatureIcon from '@/core/svg/fa/file-signature.svg';
import gearIcon from '@/core/svg/fa/gear.svg';
import handHoldingDollarIcon from '@/core/svg/fa/hand-holding-dollar.svg';
import inboxFullIcon from '@/core/svg/fa/inbox-full.svg';
import listUlIcon from '@/core/svg/fa/list-ul.svg';
import truckFastIcon from '@/core/svg/fa/truck-fast.svg';
import usersIcon from '@/core/svg/fa/users.svg';
export const appSections = {
    orders: {
        id: 'orders',
        rootPath: 'orders',
        linkTo: '/orders',
        icon: listUlIcon,
        title: t('orders.section'),
        menuItemTitle: t('orders.section'),
        claimIds: ['CustomerHeadManager', 'CustomerManager', 'SupplierHeadManager', 'SupplierManager'],
    },
    customers: {
        id: 'customers',
        rootPath: 'customers',
        linkTo: '/customers',
        title: t('clients.section'),
        icon: usersIcon,
        claimIds: ['CustomerHeadManager', 'CustomerManager'],
    },
    suppliers: {
        id: 'suppliers',
        rootPath: 'suppliers',
        linkTo: '/suppliers',
        icon: truckFastIcon, // Old one is faShippingFast.
        title: t('suppliers.section'),
        claimIds: ['SupplierHeadManager', 'SupplierManager'],
    },
    priceLists: {
        id: 'priceLists',
        rootPath: 'priceLists',
        linkTo: '/priceLists',
        icon: fileExcelIcon,
        title: t('pricelists.section'),
        claimIds: [],
    },
    stockReceipt: {
        id: 'stockReceipt',
        rootPath: 'receipt/stock',
        linkTo: '/receipt/stock',
        icon: inboxFullIcon,
        title: t('stock.receipt.section'),
        claimIds: [],
    },
    reclamations: {
        id: 'reclamations',
        rootPath: 'reclamations',
        linkTo: '/reclamations',
        icon: handHoldingDollarIcon,
        title: t('reclamations.section'),
        claimIds: [],
    },
    edo: {
        id: 'edo',
        rootPath: 'edo',
        linkTo: '/edo',
        icon: fileSignatureIcon,
        title: t('edo.section'),
        claimIds: [],
    },
    stocks: {
        id: 'stocks',
        rootPath: 'stock',
        linkTo: '/stock',
        icon: boxesStackedIcon,
        title: t('warehouses.label'),
        claimIds: [],
    },
    shipping: {
        id: 'shipping',
        rootPath: 'shipping',
        linkTo: '/shipping',
        icon: dollyIcon,
        title: t('shipping.label'),
        claimIds: ['CustomerHeadManager', 'CustomerManager'],
    },
    supplierDebtReport: {
        id: 'supplierDebtReport',
        rootPath: 'reports/suppliers',
        linkTo: '/reports/suppliers',
        icon: chartColumnIcon,
        title: t('supplier.debt.report.title'),
        menuItemTitle: t('supplier.debt.report.sidebar.menu.item.label'),
        claimIds: [],
    },
    customerDebtReport: {
        id: 'customerDebtReport',
        rootPath: 'reports/customers',
        linkTo: '/reports/customers',
        icon: chartColumnIcon,
        title: t('customer.debt.report.title'),
        menuItemTitle: t('customer.debt.report.sidebar.menu.item.label'),
        claimIds: [],
    },
    paymentReports: {
        id: 'paymentReports',
        rootPath: 'reports/payments',
        linkTo: '/reports/payments',
        icon: chartColumnIcon,
        title: t('reports-payments.section'),
        claimIds: [],
    },
    settings: {
        id: 'settings',
        rootPath: 'settings',
        linkTo: '/settings',
        icon: gearIcon,
        title: t('settings.section'),
        claimIds: ['Settings'],
    },
};
